module.exports = __webpack_public_path__ + "8ef12189d0d1a1606efdb03c33a4993a.webp";